import React, { memo, ReactElement } from "react";
import { AriaHidden } from "@swiggy-private/core-ui";

import styles from "../styles/CartDeTip.scss";

interface SubtitleProps {
    message: string;
}

const Subtitle = ({ message }: SubtitleProps): ReactElement => {
    return (
        <AriaHidden as="div" className={styles.subtitle}>
            {message}
        </AriaHidden>
    );
};

export default memo(Subtitle);
